import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import portfolioData from '../../../data/portfolio-data';

const filters = [
    { id: 1, name: "All", filterData: "all", },
    // { id: 2, name: "Interial", filterData: "interior", },
    { id: 3, name: "Architechtural", filterData: "architecture", },
    { id: 4, name: "Engineering", filterData: "engineering", },
    { id: 4, name: "Construction", filterData: "construction", },
    { id: 4, name: "Consultancy", filterData: "consultancy", },
];

const getFilteredProjects = (filterData) => {
    if (filterData === "all") {
        return portfolioData.filter((project) => project);
    }
    return portfolioData.filter((project) => project.category === filterData && project);
};
  
const PortfolioFilter = () => {
    const [filter, setFilter] = useState("all");
    const filteredProjects = getFilteredProjects(filter);
    
    return (
        <>
            <div className="gallery__area four__columns section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12 mb-40">
                            <div className="gallery__area-button t-center">
                                {filters.map(({ id, name, filterData }) => (
                                    <button key={id} onClick={() => setFilter(filterData)}
                                    className={filter === filterData ? "active" : ""}
                                    >{name}</button>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {filteredProjects.slice(0, 20)?.map((data, id) => (
                            <div className="col-xl-6 col-md-6 col-sm-12 mt-25" key={id}>
                                <div className="portfolio__four-item">
                                    {/* <Link to={`/portfolio/${data.id}`}><i className="flaticon flaticon-right-up"></i></Link> */}
                                    <img
                                            src={data.image}
                                            alt="image"
                                            style={{
                                                width: '100%',
                                                height: '480px',
                                                objectFit: 'cover',
                                                objectPosition: 'center',
                                                borderRadius: '16px'
                                            }}
                                        />
                                    { <div className="portfolio__four-item-content">
                                        <span>{data.subtitle}</span>
                                        <h5>
                                            {/* <Link to={`/portfolio/${data.id}`}> */}
                                            {data.title}
                                            {/* </Link> */}
                                            </h5>
                                    </div> }
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default PortfolioFilter;